import { render, staticRenderFns } from "./document-template-action-menu.vue?vue&type=template&id=20f452a7&"
import script from "./document-template-action-menu.vue?vue&type=script&lang=js&"
export * from "./document-template-action-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports